import React from 'react';
import {Button, Card, CardBody, Row, CardTitle, CustomInput, Label, Input, FormGroup} from "reactstrap";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import NationalId from "./components/NationalId";
import PostalCode from "./components/PostalCode";
import DriverSmartCard from "./components/DriverSmartCard";
import CarSmartCard from "./components/CarSmartCard";

class Estelam extends React.Component {
    state = {
        showResult: false,
        info: null,
        inquiryType: 1
    };

    inquiry = () => {
        if (this.state.info === null || this.state.info === "") {
            switch (this.state.inquiryType) {
                case 1:
                    this.props.showAlert("وارد كردن كد ملی اجباری میباشد!", "error");
                    break;
                case 2:
                    this.props.showAlert("لطفا کد پستی را وارد کنید!", "error");
                    break;
                case 3:
                    this.props.showAlert("لطفا شماره ملی راننده را وارد کنید!", "error");
                    break;
                case 4:
                    this.props.showAlert("لطفا شماره هوشمند ناوگان را وارد کنید!", "error");
                    break;
            }
        } else {
            this.setState({showResult: true});
        }
    }

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>استعلام</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <CardTitle>نوع استعلام</CardTitle>

                                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-100">
                                    <CustomInput
                                        lassName="w-md-25 w-50"
                                        type="radio"
                                        id="inquiryType1"
                                        name="inquiryType"
                                        label="کد ملی"
                                        checked={this.state.inquiryType === 1}
                                        onChange={() => this.setState({inquiryType: 1, showResult: false, info: ""})}
                                    />
                                    <CustomInput
                                        lassName="w-md-25 w-50"
                                        type="radio"
                                        id="inquiryType2"
                                        name="inquiryType"
                                        label="کد پستی"
                                        checked={this.state.inquiryType === 2}
                                        onChange={() => this.setState({inquiryType: 2, showResult: false, info: ""})}
                                    />
                                    <CustomInput
                                        lassName="w-md-25 w-50"
                                        type="radio"
                                        id="inquiryType3"
                                        name="inquiryType"
                                        label="کارت هوشمند راننده"
                                        checked={this.state.inquiryType === 3}
                                        onChange={() => this.setState({inquiryType: 3, showResult: false, info: ""})}
                                    />
                                    <CustomInput
                                        className="w-md-25 w-50"
                                        type="radio"
                                        id="inquiryType4"
                                        name="inquiryType"
                                        label="کارت هوشمند ناوگان"
                                        checked={this.state.inquiryType === 4}
                                        onChange={() => this.setState({inquiryType: 4, showResult: false, info: ""})}
                                    />
                                </div>
                                <div className="mt-4 ml-md-4">
                                    <a href="https://app.nwms.ir/warehouse_status">
                                        <Button color="light" size="xs" className="mx-3 my-md-0 my-1">
                                            استعلام کد پستی سامانه جامع انبارها
                                        </Button>
                                    </a>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <CardTitle>اطلاعات مورد نیاز جهت استعلام</CardTitle>

                                <div className="d-flex flex-column align-items-center">
                                    <FormGroup className="w-md-50 w-100 mx-1">
                                        {this.state.inquiryType === 1 && <Label>کد ملی</Label>}
                                        {this.state.inquiryType === 2 && <Label>کد پستی</Label>}
                                        {this.state.inquiryType === 3 && <Label>شماره ملی راننده</Label>}
                                        {this.state.inquiryType === 4 && <Label>شماره هوشمند ناوگان</Label>}

                                        <Input value={this.state.info} maxLength={11}
                                               onChange={(e) => this.setState({info: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    </FormGroup>

                                    <Button outline color="primary" className="mx-3 my-md-0 my-1"
                                            onClick={() => this.inquiry()}>
                                        استعلام
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {this.state.showResult ?
                    <Row className="mb-3">
                        <Colxx xxs="12">
                            <Card>
                                {this.state.inquiryType === 1 &&
                                <NationalId
                                    nationalId={this.state.info}
                                    showSpinner={this.props.showSpinner}
                                    hideSpinner={this.props.hideSpinner}
                                    showAlert={this.props.showAlert}
                                />
                                }
                                {this.state.inquiryType === 2 &&
                                <PostalCode
                                    postalCode={this.state.info}
                                    showSpinner={this.props.showSpinner}
                                    hideSpinner={this.props.hideSpinner}
                                    showAlert={this.props.showAlert}
                                />
                                }
                                {this.state.inquiryType === 3 &&
                                <DriverSmartCard
                                    driverSmartCard={this.state.info}
                                    showSpinner={this.props.showSpinner}
                                    hideSpinner={this.props.hideSpinner}
                                    showAlert={this.props.showAlert}
                                />
                                }
                                {this.state.inquiryType === 4 &&
                                <CarSmartCard
                                    carSmartCard={this.state.info}
                                    showSpinner={this.props.showSpinner}
                                    hideSpinner={this.props.hideSpinner}
                                    showAlert={this.props.showAlert}
                                />
                                }
                            </Card>
                        </Colxx>
                    </Row>
                    :
                    null
                }
            </>
        )
    }
}

export default Estelam;